import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private secretKey: string = environment.secretPortal;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  addObjectStorageEcrypted<T>(obj: T, key: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const json = JSON.stringify(obj);
    const data = CryptoJS.AES.encrypt(json, this.secretKey).toString();
    localStorage.setItem(key, data);
  }

  getObjectStorageDecrypt<T = any>(key: string): T | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    const txtEcrypted = localStorage.getItem(key);
    if (!txtEcrypted) {
      return null;
    }

    const json = CryptoJS.AES.decrypt(txtEcrypted, this.secretKey).toString(CryptoJS.enc.Utf8);
    return json ? JSON.parse(json) : null;
  }

  add(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }

  get(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
    return null;
  }

  removeItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }

  public clearData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
